const tabs  = {
    RECORDINGS: 'recordings',
    FILES: 'files',
    PARTICIPANTS: 'participants',
    CHAT: 'chat'
};


export default tabs;
